var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4485 32.5831C49.4485 30.6777 47.9039 29.1331 45.9985 29.1331C44.0931 29.1331 42.5485 30.6777 42.5485 32.5831V47.8464L55.5848 56.537C57.1702 57.5939 59.3122 57.1655 60.3691 55.5801C61.426 53.9947 60.9976 51.8527 59.4122 50.7958L49.4485 44.1536V32.5831Z",
    fill: "#362F73",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 46C80.5 65.0538 65.0538 80.5 46 80.5C26.9462 80.5 11.5 65.0538 11.5 46C11.5 26.9462 26.9462 11.5 46 11.5C65.0538 11.5 80.5 26.9462 80.5 46ZM72.8333 46C72.8333 60.8196 60.8196 72.8333 46 72.8333C31.1804 72.8333 19.1667 60.8196 19.1667 46C19.1667 31.1804 31.1804 19.1667 46 19.1667C60.8196 19.1667 72.8333 31.1804 72.8333 46Z",
    fill: "#362F73",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlined);
export default __webpack_public_path__ + "static/media/outlined.8e0d09763ca9b2c9f95677f4c22e9c6d.svg";
export { ForwardRef as ReactComponent };